import React from 'react';
import autobind from 'autobind-decorator';
import { Link } from 'react-router';
import {
  getCookie,
  setCookie,
} from 'acast-www-uikit/dist/components/cookie-consent/utils';

import StringStore from 'client/stores/strings';
import Button from 'client/components/common/button-rounded';

import baseUrl from 'server/routes/base-url';

const deriveStateFromCookies = ({ performanceCookies } = {}) => ({
  didMakeChoice: typeof performanceCookies === 'boolean',
});

class Consent extends React.Component {
  constructor(props) {
    super(props);
    this.state = { didMakeChoice: true };
  }

  componentDidMount() {
    this.updateState();
  }

  @autobind
  onChoice(value) {
    return () => {
      setCookie({ performanceCookies: value });
      this.updateState();
    };
  }

  @autobind
  updateState() {
    this.setState(deriveStateFromCookies(getCookie()));
  }

  render() {
    if (this.state.didMakeChoice) return null;

    const cookiePolicyUrl = `${baseUrl}cookies`;

    return (
      <section className="consent">
        <div className="consent-pitch">
          We use cookies on our website to improve your user experience and to
          collect statistical data such as number of unique visitors and time
          spent on our website. By accepting this policy, you agree to the use
          of cookies and similar technologies. You can change your cookie
          settings at any time by following{' '}
          <Link to={cookiePolicyUrl}>this link</Link>. You may also disable or
          block cookies by setting your browser preferences. For more
          information on how we use cookies, please read our{' '}
          <Link to={cookiePolicyUrl}>Cookie Policy</Link>.
        </div>
        <div className="consent-actions">
          <div className="consent-button">
            <Button
              variant="button-rounded-white button-rounded-small"
              onClick={this.onChoice(false)}
            >
              {StringStore.get('consent.noThanks')}
            </Button>
          </div>
          <div className="consent-button">
            <Button
              variant="button-rounded-yellow button-rounded-small"
              onClick={this.onChoice(true)}
            >
              {StringStore.get('consent.accept')}
            </Button>
          </div>
        </div>
      </section>
    );
  }
}

export default Consent;



// WEBPACK FOOTER //
// ./client/components/consent/consent.es6